export interface GraphConfigType {
  graphMeEndpoint: string;
}

export interface ResponseCallbackType {
  (token: string): void;
}

export interface OptionsType {
  method: string;
  headers: {
    Authorization: string;
  }
}

export type ScopeKeys = 'main' | 'onboarding';

export interface ScopesType {
  main: string;
  onboarding: string;
}

export const StatusType = {
  Rejected: 'Rejected',
  Hold: 'Hold',
  Prospect: 'Prospect',
  Client: 'Client',
  Employee: 'Employee',
  Clearance: 'Clearance',
} as const

export const statusTypes = ['Rejected', 'Hold', 'Prospect', 'Client', 'Employee', 'Clearance'] as const

export type StatusType = typeof statusTypes[number];

export type PathType = 'CorpAOF' | 'DeliverableAOF' | 'IndividualAOF';

export interface UserStatusType {
  status: StatusType;
}

export interface NavigateMapType {
  Rejected: string;
  Hold: string;
  Prospect: string;
  Client: string;
  Employee: string;
  Clearance: string;
}

export interface ParseUserStatusOutput {
  navigateTo: string;
}

export interface TokenDataType {
  aud?: string[] | string;
  azp?: string[] | string;
  emails?: string[];
  iss?: string;
  sub?: string;
  exp?: number;
  nbf?: number;
  iat?: number;
  jti?: string;
  idp?: string;
  oid?: string;
  scp?: string;
  tfp?: string;
  ver?: string;
  name?: string;
  nonce?: string;
  idp_access_token?: string;
  extension_UserStatus?: StatusType;
  extension_IsAdmin?: boolean;
}
